import { all, call, debounce, fork, put, select, take, takeEvery, takeLatest } from "redux-saga/effects";

import {
    FAVORITE_FORM_UPDATED,
    FAVORITE_FORMS_LOADED,
    FORM_CLOSED,
    HISTORY_FORMS_INFO_UPDATED,
    MENU_ITEMS_LOADED,
} from "@multiweb/reactCore/bridge";
import { createAreLocalizationKeysLoadedActionPattern } from "@multiweb/reactCore/i18n";
import { EMPTY_ARRAY } from "@multiweb/reactUtils";
import { SagaWithReturnType } from "@multiweb/types/react";
import {
    ADD_PROFILE_TO_RELATIONSHIPS,
    FETCHING_KEY_FORM_ITEMS_LOCALIZATION,
    RELOAD_MENU,
    REMOVE_PROFILE_FORM_RELATIONSHIPS,
} from "../constants";
import { REMOVE_LABEL_INFO, SET_LABEL_INFO } from "../openedItems";
import { formOpenedAndShowInMenuActionPattern } from "../utils";
import { createSetSearchResultsAction } from "./actions";
import { SEARCHED_TEXT_CHANGED } from "./constants";
import { getSearchedItems, isSearchActive } from "./selectors";

export const saga: SagaWithReturnType = function* searchModuleSaga() {
    yield fork(prepareMenuItemSearchSaga);
    yield debounce(200, SEARCHED_TEXT_CHANGED, searchSaga);
    yield takeEvery([
        formOpenedAndShowInMenuActionPattern,
        FORM_CLOSED,
        FAVORITE_FORM_UPDATED,
        SET_LABEL_INFO,
        REMOVE_LABEL_INFO,
        REMOVE_PROFILE_FORM_RELATIONSHIPS,
        ADD_PROFILE_TO_RELATIONSHIPS,
    ], searchSaga);
    yield takeLatest(RELOAD_MENU, refreshSearchAfterMenuReloadSaga);
};

/**
 * Po spuštění čeká na akci načtení lokalizací pro položky menu.  Poté naplní cache používané pro vyhledávání položek menu, aby první vyhledání proběhlo s optimální
 * rychlostí.
 */
export const prepareMenuItemSearchSaga: SagaWithReturnType = function* prepareMenuItemSearchSaga() {
    yield take(createAreLocalizationKeysLoadedActionPattern(FETCHING_KEY_FORM_ITEMS_LOCALIZATION));
    yield select(getSearchedItems);
};

/**
 * Obnovuje výsledky vyhledávání po znovunačtení menu.
 * Výsledky jsou znovunačteny poté, co jsou dokončeny následující akce:
 * - načtení lokalizací pro položky menu
 * - načtení historicky otevřených formulářů
 * - načtení oblíbených formulářů
 * - načtení položek menu
 */
export const refreshSearchAfterMenuReloadSaga: SagaWithReturnType = function* refreshSearchAfterMenuReloadSaga() {
    yield all([
        take(createAreLocalizationKeysLoadedActionPattern(FETCHING_KEY_FORM_ITEMS_LOCALIZATION)),
        take(HISTORY_FORMS_INFO_UPDATED),
        take(FAVORITE_FORMS_LOADED),
        take(MENU_ITEMS_LOADED),
    ]);
    yield call(searchSaga);
};

/**
 * Spouští vyhledávání a nastavuje výsledky do stavu.
 */
export const searchSaga: SagaWithReturnType = function* searchSaga() {
    const searchIsActive: ReturnType<typeof isSearchActive> = yield select(isSearchActive);
    const searchedItems: ReturnType<typeof getSearchedItems> | typeof EMPTY_ARRAY = searchIsActive ? yield select(getSearchedItems) : EMPTY_ARRAY;
    yield put(createSetSearchResultsAction(searchedItems));
};
